//#region src/Tabs/utils.ts
function makeTriggerId(baseId, value) {
	return `${baseId}-trigger-${value}`;
}
function makeContentId(baseId, value) {
	return `${baseId}-content-${value}`;
}

//#endregion
export { makeContentId, makeTriggerId };
//# sourceMappingURL=utils.js.map